import React, { Component } from 'react'
import Grid from "../../components/grid";
import { connect } from "react-redux";
import Plus_icon from '../../assets/images/plus_icon.png'
import './style.scss';
import { getCensusRecords, saveCensusRecords, GetEins } from '../../store/actions';
import { startOfDay, subDays, subMonths } from 'date-fns';
import { has } from 'lodash';
import FileUpload from '../../components/file-upload';
import { read, utils } from 'xlsx';
class PPDCensusView extends Component {

    state = {
        einList: [],
        pinnedTopRowData: [{
            date: ""
        }],
        censusData: [],
        columnDefs: [],
        showFileUpload: false,
        src: null,
        file: null,
        fileConvertError: false,
        uploadFileName: null,
        dragging: false,
    };

    onGridReady = async (params) => {
        this.gridApi = params.api;
    };

    getCensusData = async payload => {
        await this.props.getCensusRecords(this.props.UserReducer.companyId, payload);
    };

    loadMore = async () => {
        let { startDate } = this.state;
        let dateFrom = Date.parse(startOfDay(subDays(startDate, 31)));
        let dateTo = Date.parse(startOfDay(subDays(startDate, 1)));
        await this.getCensusData({ startDate: dateFrom, endDate: dateTo });
        let { rowData } = this.state;
        let moreData = [...this.props.PPD_CENSUS_DATA, ...rowData].sort((a, b) => a.date - b.date);
        this.setState({ rowData: moreData, startDate: dateFrom });
    }

    onCellValueChange = async props => {
        let { data, value, colDef } = props;
        let { company, date } = data;
        let censusRecord = { company, date }
        if (this.state.isMultiEIN) {
            let { headerName } = colDef;
            let colData = data[headerName];
            censusRecord.EINName = colData.EINName;
        }
        censusRecord.census = value;
        this.props.saveCensusRecords(censusRecord)
        return;
    };

    onFirstDataRender = props => {
        this.gridApi.ensureIndexVisible(this.state.rowData.length - 1, "bottom");
    }

    saveRecords = (records) => {
        let data = records.reduce((all, row) => {
            if (this.state.isMultiEIN) {
                for (let ein in row) {
                    if (row[ein].EINName && row[ein].census) {
                        row[ein].date = row.date;
                        row[ein].company = row.company;
                        all.push(row[ein]);
                    };
                };
            } else {
                all.push(row)
            };
            return all;
        }, [])
        this.props.saveCensusRecords(data);
    };

    addCensusRecs = () => {
        this.setState({ showFileUpload: true });
    };

    onSelectFileUpload = (e, drop) => {
        e.preventDefault();
        let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
        if (!file) return;
        let reader = new FileReader();
        this.setState({
            file: file,
            fileConvertError: null,
            uploadFileName: file.name,
        });
        reader.readAsDataURL(file);
        reader.onload = (res) => this.setState({ src: res.target.result });
    };

    uploadFile = async () => {
        const i = this.state.src.indexOf("base64,");
        let workbook = read(this.state.src.slice(i + 7), { type: "base64", cellDates: true });
        let worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let wsData = utils.sheet_to_json(worksheet);
        let data = wsData.map(el => {
            el.company = this.props.UserReducer.companyId;
            el.date = Date.parse(startOfDay(el.Date));
            delete el.Date;
            if (this.state.isMultiEIN) {
                this.state.einList.forEach(ein => {
                    let census = el[ein.companyEIN];
                    el[ein.companyEIN] = {
                        census,
                        EINName: ein.companyEIN
                    };
                });
            } else {
                if (el.hasOwnProperty("Census")) {
                    el.census = el.Census;
                    delete el.Census;
                };
            };
            return el;
        });

        let rowData = this.state.rowData;
        let uploadedDates = data.map(el => el.date);
        let override = rowData.filter(el => {
            let exists = uploadedDates.includes(el.date);
            return !exists;
        });
        let censusData = [...override, ...data].sort((a, b) => a.date - b.date);
        this.saveRecords(censusData);
        this.setState({
            src: null,
            uploadFileName: "",
            showFileUpload: false,
            rowData: censusData
        }, () => {
            let index = this.state.rowData.length - 1;
            this.gridApi.ensureIndexVisible(index, "bottom");
        });
    };

    LoadMoreComponent = () => {
        return (
            <>
                <div className="action">
                    <a role='button' className="link-primary" onClick={this.loadMore} aria-disabled={this.state.rowData && this.state.rowData.length >= 1000} >Load More...</a>
                </div>
            </>
        )
    }

    async componentDidMount() {
        let endDate = Date.now()
        let startDate = Date.parse(startOfDay(subMonths(endDate, 1)));
        let isMultiEIN = has(this.props.ClientDataReducer, "isMultiEIN") ? this.props.ClientDataReducer.isMultiEIN : this.props.UserReducer.companyDetails.isMultiEIN;
        await this.getCensusData({ startDate, endDate });
        let censusData = this.props.PPD_CENSUS_DATA;
        let columnDefs = [{
            headerName: "Date",
            field: "date",
            isFullWidthRow: params => params.node.rowPinned,
            valueFormatter: params => new Date(params.value).toLocaleDateString(),
            fullWidthCellRenderer: this.LoadMoreComponent,
            pinned: 'left',
            width: 100,
            cellRendererSelector: (params) => {
                if (params.node.rowPinned) {
                    return {
                        component: this.LoadMoreComponent
                    };
                }
            }
        }];
        let einList = [];
        if (isMultiEIN) {
            await this.props.GetEins(this.props.UserReducer.companyId);
            einList = this.props.EINS.records;
            einList.forEach(ein => {
                let { companyEIN } = ein;
                columnDefs.push({
                    headerName: companyEIN,
                    field: `${companyEIN}.census`,
                    editable: params => !params.node.rowPinned,
                    cellEditor: "agNumberCellEditor",
                    cellEditorParams: {
                        step: 1,
                        showStepperButtons: true,
                        min: 0
                    },
                    singleClickEdit: props => !props.value
                });
            });
        } else columnDefs.push({
            headerName: "Census",
            field: "census",
            editable: params => !params.node.rowPinned,
            cellEditor: "agNumberCellEditor",
            cellEditorParams: {
                step: 1,
                showStepperButtons: true,
                min: 0
            },
            singleClickEdit: props => !props.value
        });
        this.setState({ startDate, endDate, isMultiEIN, einList, columnDefs, rowData: censusData });
    };

    render() {
        const { rowData, columnDefs, showFileUpload, pinnedTopRowData } = this.state;
        return (
            <div>
                <div className="route_page rate_setup_page location-wage">
                    <div className="rates_list">
                        <h4 className="heading_h4">Census</h4>
                        <div className="list">
                            <Grid
                                rowData={rowData}
                                columnDefs={columnDefs}
                                height="650px"
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChange}
                                onFirstDataRendered={this.onFirstDataRender}
                                pinnedTopRowData={pinnedTopRowData}
                                showStatusBar={true}
                            >
                            </Grid>
                            {showFileUpload ?
                                <FileUpload
                                    HtmlFor="upld_census_file"
                                    CAPTION="UPLOAD CENSUS RECORDS"
                                    FileError={this.state.fileConvertError}
                                    OnSelectFile={this.onSelectFileUpload}
                                    UploadFile={this.uploadFile}
                                    Color="#006874"
                                    Accept=".csv,.xls,.xlsx"
                                    ButtonText="Import Records"
                                /> :
                                <div onClick={this.addCensusRecs} className="df acsa add_rate">
                                    <img src={Plus_icon} />
                                    <p>Upload Records</p>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = ({ UserReducer, PPDReducer, EINReducer, ClientDataReducer }) => {
    let { PPD_CENSUS_DATA } = PPDReducer;
    let { EINS } = EINReducer;
    return { UserReducer, PPD_CENSUS_DATA, EINS, ClientDataReducer };
};
export default connect(mapStateToProps, { getCensusRecords, saveCensusRecords, GetEins })(PPDCensusView);
